// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lm-0";